export const WarrantyRejectRegistrationReportConstants ={
    GETALL_REQUEST: 'WARRANTY_GETALL_REQUEST',
    GETALL_SUCCESS: 'WARRANTY_GETALL_SUCCESS',
    GETALL_FAILURE: 'WARRANTY_GETALL_FAILURE',

    GETEXPORT_REQUEST: 'WARRANTY_GETEXPORT_REQUEST',
    GETEXPORT_SUCCESS: 'WARRANTY_GETEXPORT_SUCCESS',
    GETEXPORT_FAILURE: 'WARRANTY_GETEXPORT_FAILURE',

    LOADING_REQUEST: 'LOADING_REQUEST',
}